import { Button, Select } from '@nvision/ui';

import { Card } from '@/components/card';

import { useAccessorialsControls } from '../../../hooks';

import styles from './accessorials-controls.module.css';

export const AccessorialsControls: React.FC = () => {
  const { addAccessorial, changeSort, deleteAccessorials, isDeleteDisabled, selectedSortOption, sortOptions } =
    useAccessorialsControls();

  return (
    <Card>
      <Card.Header title="Accessorial Results" />
      <Card.Main>
        <div className={styles.controls}>
          <div className={styles.leftSection}>
            <Select
              options={sortOptions}
              value={selectedSortOption}
              placeholder="Select"
              onSelectionChange={changeSort}
              className={styles.sortSelect}
              size="sm"
            />
          </div>

          <div className={styles.rightSection}>
            <Button size="sm" iconLeft="trash" onClick={deleteAccessorials} isDisabled={isDeleteDisabled} ghost>
              Delete
            </Button>
            <Button size="sm" iconLeft="circle-plus" onClick={addAccessorial} primary>
              Add Accessorial
            </Button>
          </div>
        </div>
      </Card.Main>
    </Card>
  );
};
